var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"code":_vm.$t('views.notFound.code'),"page-title":_vm.$t('views.notFound.error'),"message":_vm.$t('views.notFound.message')}})}
var staticRenderFns = []

export { render, staticRenderFns }